(function () {
  'use strict';

  function arrange() {
    var container = document.querySelector('.product__info-container');
    if (!container) return;
    var details = container.querySelector('details.tq-pd');
    var pickup = container.querySelector('pickup-availability');
    if (!details || !pickup) return;
    if (details.nextElementSibling === pickup) return;
    details.insertAdjacentElement('afterend', pickup);
  }

  function run() {
    arrange();
    var container = document.querySelector('.product__info-container');
    if (container && window.MutationObserver) {
      var mo = new MutationObserver(function () { arrange(); });
      mo.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
